/* eslint-disable */
(function (window) {
  let WORKER_PATH = './static/recorderWorker.js'

  let Recorder = function (cfg) {
    let config = cfg || {}
    let bufferLen = config.bufferLen || 4096
    let recording = false
    let currCallback
    let worker = new window.Worker(config.workerPath || WORKER_PATH)
    let audioContext
    window.AudioContext = window.AudioContext || window.webkitAudioContext
    window.URL = window.URL || window.webkitURL
    navigator.getUserMedia = (navigator.getUserMedia ||
                     navigator.webkitGetUserMedia ||
                     navigator.mozGetUserMedia ||
                     navigator.msGetUserMedia)

    this.configure = (cfg) => {
      for (let prop in cfg) {
        if (cfg.hasOwnProperty(prop)) {
          config[prop] = cfg[prop]
        }
      }
    }

    this.startUserMedia = (stream) => {
      if (stream.getTracks().length) {
        audioContext = new window.AudioContext()
        let input = audioContext.createMediaStreamSource(stream)

        this.stream = stream.getTracks()[0]
        window.console.log('Recorder initialised.')

        recording = true

        let context = input.context
        let node = (context.createScriptProcessor || context.createJavaScriptNode).call(context, bufferLen, 2, 2)
        node.onaudioprocess = (e) => {
          if (!recording) {
            return
          }

          worker.postMessage({
            command: 'record',
            buffer: [
              e.inputBuffer.getChannelData(0)
              // e.inputBuffer.getChannelData(1)
            ]
          })
        }

        worker.postMessage({
          command: 'init',
          config: {
            sampleRate: context.sampleRate
          }
        })

        input.connect(node)
        node.connect(context.destination)
      }
    }

    this.record = () => {
      try {
        navigator.getUserMedia({ audio: true }, this.startUserMedia, (e) => {
          throw new Error('No live audio input: ' + e)
        })
      } catch (e) {
        throw new Error('No web audio support in this browser!')
      }
    }

    this.stop = () => {
      this.stream.stop()
      recording = false
    }

    this.clear = () => {
      worker.postMessage({ command: 'clear' })
      audioContext.close()
    }

    this.getBuffer = (cb) => {
      currCallback = cb || config.callback
      worker.postMessage({ command: 'getBuffer' })
    }

    this.exportBlob = (cb, type) => {
      currCallback = cb || config.callback
      type = type || config.type || 'audio/wav'
      if (!currCallback) {
        throw new Error('Callback not set')
      }

      worker.postMessage({
        command: 'exportBlob',
        type: type
      })

      worker.onmessage = (e) => {
        let blob = e.data
        let fileReader = new window.FileReader()
        fileReader.readAsArrayBuffer(blob)
        currCallback(blob)
      }
    }
  }

  window.Recorder = Recorder

})(window)



// WEBPACK FOOTER //
// ./src/components/live-player/components/modules/recorder.js